"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderWithConfirmation = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _useTracking2 = require("../../hooks/useTracking");
var _LocaleProvider = require("../LocaleProvider");
var _Image = require("../Image");
var _formatPrice = require("../../utils/formatPrice");
var _ButtonGroup = require("../ButtonGroup");
var PREFIX = (0, _getPrefixCls.getPrefixCls)('order-with-confirmation');
var OrderWithConfirmation = function OrderWithConfirmation(props) {
  var image = props.image,
    title = props.title,
    statusText = props.statusText,
    totalPrice = props.totalPrice,
    _props$showButtons = props.showButtons,
    showButtons = _props$showButtons === void 0 ? true : _props$showButtons,
    buttonGroup = props.buttonGroup;
  var _useTracking = (0, _useTracking2.useTracking)(props),
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    region = _useLocale.region,
    trans = _useLocale.trans;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: PREFIX
  }, trackingImpressionProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-header")
  }, trans('landing_page_small_order_card_header') || 'Do you want to enquire about this order?'), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-body")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-order")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-order__image")
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, {
    src: image
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-order__main-info")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-order__title")
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-order__details")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-order__status")
  }, statusText), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-order__total-price")
  }, (0, _formatPrice.formatPrice)(region, totalPrice))))), showButtons && buttonGroup && /*#__PURE__*/_react.default.createElement(_ButtonGroup.ButtonGroup, (0, _extends2.default)({}, buttonGroup, {
    className: "".concat(PREFIX, "-buttons")
  }))));
};
exports.OrderWithConfirmation = OrderWithConfirmation;